// extracted by mini-css-extract-plugin
export default {"title":"EditorEditableTitle_title__zjJ2f","textWrapper":"EditorEditableTitle_textWrapper__OR8a0"};